module.exports = __webpack_public_path__ + "img/second-name.c3fe1659.svg";